<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/purchase/receipts">{{ $t('expense_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('expense_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.VendorId.$error }">
                                <label class="label-control blue">{{$t('vendor')}}</label>
                                <div>
                                    <VendorSelector :value="header.VendorName" place="Choose a vendor" @select="vendorSelected" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.Date.$error }">                                
                                <DatePicker v-model="$v.header.Date.$model" :label="$t('date')"/>                        
                            </div>                            
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.AccountId.$error }">
                                <label class="label-control blue">{{$t('payment_menthod')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.header.AccountId.$model">
                                        <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 40px;"><input type="checkbox" v-model="isCheckAll" /></th>
                                        <th>{{$t('description')}}</th>
                                        <th>{{$t('due_date')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('original_amount')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('open_balance')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('payment')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td class="text-center"><input type="checkbox" v-model="ret.Checked" @change="isCheck(ret)" /></td>
                                        <td>{{ret.Num}} ({{$format(ret.Date,'DD-MM-YYYY')}})</td>
                                        <td>{{$format(ret.DueDate,'DD-MM-YYYY')}}</td>
                                        <td class="text-right">{{$money(ret.OriginalAmount)}}</td>
                                        <td class="text-right">{{$money(ret.Balance)}}</td>
                                        <td class="cell-input">
                                            <input type="text" class="form-control form-control-sm text-right" v-model="ret.PaymentAmount" @blur="calculate" style="font-size: 14px;">
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="5" class="text-right">Total Amount: </td>
                                        <td class="text-right">{{$money(header.TotalAmount)}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group class="label-control blue" :label="$t('description')">
                                <b-form-textarea v-model="header.Description" />
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DatePicker from "../Components/DatePicker.vue"
    import { required } from 'vuelidate/lib/validators';
    import Purchase from '../../shared/models/Purchase';
    import Accounting from '../../shared/models/Accounting';
    import { VendorSelector } from '../Vendors';
    import Swal from 'sweetalert2';
    export default {
        components: { VendorSelector, DatePicker },
        data() {
            return {
                header: {
                    VendorId: '',
                    VendorName: '',
                    Date: this.$now().format('YYYY-MM-DD'),
                    AccountId: '',
                    TotalAmount: 0
                },
                lines: [],
                banks: [],
                isUpdate: false,
                isCheckAll: false
            }
        },
        validations: {
            header: {
                VendorId: { required },
                AccountId: { required },
                Date: { required },
            }
        },
        created() {
            Accounting.getByTypeNames({ AccountTypeNames: ['Bank'] }).then(res => {
                this.banks = res.Accounts;
            });
            let id = this.$route.params.id;
            if (id != undefined && id != null && id != '') {
                this.isUpdate = true;
                this.findById(id);
            }
        },
        methods: {
            vendorSelected(e) {
                if (e.type == 3) {
                    var loading = this.$loading.show();
                    this.header.VendorId = e.data.Id;
                    this.header.VendorName = e.data.Name;
                    Purchase.select({ VendorId: e.data.Id, Statuses: ['Not Paid', 'Partially Paid'] }).then(res => {
                        this.makeLine(res.Data);
                        this.calculate();
                    }).finally(() => { loading.hide(); });
                }
                this.isCheckAll = false;
            },
            findById(id) {
                let loading = this.$loading.show();
                Purchase.findPaymentById({ Id: id }).then(res => {
                    this.header = res.Header;
                    this.lines = res.Lines;
                    this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                }).finally(() => { loading.hide(); });
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let lines = this.lines.filter(el => el.Checked == true);
                    if (lines.length == 0) return Swal.fire('Message', 'Please check payment amount again.', 'warning');
                    this.header.CompanyId = this.$store.state.company.Id;
                    this.header.ClientId = this.$store.state.company.ClientId;
                    let req = {
                        Header: this.header,
                        Lines: this.lines.filter(el => el.Checked == true)
                    };
                    let loading = this.$loading.show();
                    Purchase.savePayment(req, this.isUpdate).then(() => {
                        this.$router.go(-1);
                    }).finally(() => { loading.hide(); });
                }
            },
            makeLine(records) {
                this.lines = [];
                records.forEach((el, index) => {
                    this.lines.push({
                        LineNo: index,
                        PurchaseInvoiceId: el.Id,
                        Num: el.Num,
                        Date: el.Date,
                        DueDate: el.DueDate,
                        OriginalAmount: el.PaidAmount,
                        Balance: el.Balance,
                        PaymentAmount: 0
                    });
                });
            },
            calculate() {
                let total = 0;
                this.lines.forEach(el => {
                    total += Number(el.PaymentAmount);
                });
                this.header.TotalAmount = total;
            },
            isCheck(item) {
                if (item.Checked) item.PaymentAmount = item.Balance;
                else item.PaymentAmount = 0;
                this.calculate();
            }
        },
        watch: {
            isCheckAll(value) {
                this.lines.forEach(el => {
                    el.Checked = value;
                    if (el.Checked) el.PaymentAmount = el.Balance;
                    else el.PaymentAmount = 0;
                });
                this.calculate();
            }
        }
    }
</script>